import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
} from "react-router-dom";
import ExpenseDashboard from "Module/Subscription/ConfigMode/Pay/Expense/Dashboard";
import PageNotFound from "../../Component/NotFound/index";
import RunPayroll from "./Payroll/RunPayroll";
import StartPayroll from "./Startpayroll";


const PayrollRoutes = ({ match }) => (
  <div>
    <Switch>
      <Route exact path={`${match.path}/payroll/run/:pid/:id`} component={RunPayroll} />
      <Route path={`${match.path}/expense`} component={ExpenseDashboard} />
      <Route path={`${match.path}/payroll`} component={StartPayroll} />
      {/* <Route exact path={`${match.path}/drive`} component={HrDrive} /> */}
      <Route path="**" component={PageNotFound} />
    </Switch>
  </div>
);

export default withRouter(PayrollRoutes);
